import { Button, Tabs, Tooltip, Select } from "antd";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addTrackedItemsRoute, viewTrackedItemChartRoute, } from "../../../../../../core/constants/routesPath";
import { SessionVariables } from "../../../../../../core/constants/SessionVariables";
import { SessionStorage } from "../../../../../../core/helpers/localStorage/sessionStorage";
import UsePrintPage from "../../../../../../core/hooks/usePrintPage";
import localize from "../../../../../../core/utils/translation-files";
import UserCreatedTrackedItemsListingContainer from "./user-created-tracked-items";
import SystemCreatedTrackedItemsListingContainer from "./system-created-tracked-items";
import isActionAllowed from "../../../../../../core/authorization/userPermissions";
import { REPORT_CREATION } from "../../../../../../core/constants/permissionConstants";
import UsePersistCustomFilters from "../../../../../../core/hooks/usePersistCustomFilters";
import FiltersDropdownMenu from "../../../../../../layout/components/select/FiltersDropdownMenu";
import RenderSvg from "../../../../../../layout/components/icons/RenderSvg";
import SelectedListingFilters from "../../../../../../layout/components/selectedListingFilters";
import PrintButton from "../../../../../../layout/components/common/PrintButton";
import Header from "../../../../../../layout/components/common/header";
import ListingSearch from "../../../../../../layout/components/listingSearch";
import isEmpty from "../../../../../../core/helpers/isEmpty";
import { TrackedItemsVariables } from "../../../../../../core/constants/TrackedItemsConstants";
import { clearSearchInputSuccess } from "../../../../../../redux/listingSearchInput/actions";
import { clearTags, getTags, getMoreTags } from "../../../../../../redux/tags/actions";
const ManageTrackedItemContainer = (props) => {
    var _a;
    const { TabPane } = Tabs;
    const dispatch = useDispatch();
    const { setFilters, filters } = UsePersistCustomFilters({
        additionalPersistRoutes: [viewTrackedItemChartRoute],
        defaultValue: {},
    });
    // const hist = useHistory();
    // const { browserHistory } = useContext(browserHistoryMemoryContext);
    // const history = useMemo(() => {
    //   return browserHistory ?? hist;
    // }, [browserHistory, hist]);
    // const dispatch = useDispatch();
    const [selectedTab, setSelectedTab] = useState(SessionStorage.getKey(SessionVariables.SELECTED_MANAGE_TRACKED_ITEM_TAB) ||
        "1");
    const [isSubmitAction, setIsSubmitAction] = useState(false);
    const [selectedTag, setSelectedTag] = useState(SessionStorage.getKey("tiTag", sessionStorage) || undefined);
    const [lastActionType, setLastActionType] = useState(null);
    const [tagDropdownOpen, setTagDropdownOpen] = useState(false);
    const [tagSearchRaw, setTagSearchRaw] = useState("");
    const [tagSearch, setTagSearch] = useState("");
    const prevTagSearchRef = useRef("");
    const { items: availableTags = [], page: tagPage = 0, last: tagLast = false, } = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.tags) !== null && _a !== void 0 ? _a : {}; });
    const [tagSelectLoading, setTagSelectLoading] = useState(false);
    const TAG_PAGE_SIZE = 10;
    const tagsInitialLoadRef = useRef(false);
    // const searchValue = useSelector(
    //   (state: RootStateOrAny) => state?.searchInput
    // );
    // const history = useHistory();
    // const queryParams = history.location.state?.queryParams;
    // const searchValue = queryParams?.searchInput || "";
    // const searchValue = useSelector(
    //   (state: RootStateOrAny) => state?.searchInput
    // );
    const history = useHistory();
    const queryParams = (_a = history.location.state) === null || _a === void 0 ? void 0 : _a.queryParams;
    const searchValue = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.searchInput) || "";
    const currentSearch = useRef(searchValue);
    const handleChange = (activeKey) => {
        var _a, _b;
        if (activeKey !== selectedTab) {
            if (((_a = currentSearch.current) === null || _a === void 0 ? void 0 : _a.length) !== 0 && ((_b = currentSearch.current) === null || _b === void 0 ? void 0 : _b.length) < TrackedItemsVariables.MINIMUM_SEARCH_LENGTH) {
                history.push(history.location.pathname, Object.assign(Object.assign({}, queryParams), { searchInput: "", subject: "" }));
            }
            dispatch(clearSearchInputSuccess());
            setSelectedTab(activeKey);
            SessionStorage.setKey(SessionVariables.SELECTED_MANAGE_TRACKED_ITEM_TAB, activeKey);
            setSelectedTab(activeKey);
            setIsSubmitAction(true);
        }
    };
    const handleChangeFilters = (filterValues) => {
        setFilters(Object.assign(Object.assign({}, filters), { trackedItem_filters: filterValues }));
    };
    const tabFilterValue = useCallback((tabKey) => { var _a; return (_a = filters === null || filters === void 0 ? void 0 : filters["trackedItem_filters"]) !== null && _a !== void 0 ? _a : {}; }, [filters]);
    const handleApplyFilter = () => {
        setIsSubmitAction(true);
    };
    const { handlePrint, nodeRef } = UsePrintPage();
    useEffect(() => {
        setTimeout(() => {
            const storageActiveTab = SessionStorage.getKey(SessionVariables.SELECTED_MANAGE_TRACKED_ITEM_TAB);
            if (storageActiveTab !== selectedTab && !isEmpty(storageActiveTab)) {
                setSelectedTab(storageActiveTab);
            }
        }, 10);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        const id = setTimeout(() => setTagSearch(tagSearchRaw.trim()), 300);
        return () => clearTimeout(id);
    }, [tagSearchRaw]);
    const fetchTags = useCallback((search = "") => {
        setTagSelectLoading(true);
        dispatch(clearTags());
        dispatch(getTags({ page: 0, size: TAG_PAGE_SIZE, search })).finally(() => setTagSelectLoading(false));
    }, [dispatch]);
    useEffect(() => {
        if (!tagsInitialLoadRef.current) {
            tagsInitialLoadRef.current = true;
            fetchTags("");
            return;
        }
        if (tagSearch !== undefined && tagSearch !== null)
            fetchTags(tagSearch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tagSearch, fetchTags]);
    const handleTagSelectChange = (value) => {
        setSelectedTag(value || undefined);
        SessionStorage.setKey("tiTag", value || null, sessionStorage);
        setLastActionType("tag");
        // if (value) {
        history.push(history.location.pathname, Object.assign(Object.assign({}, queryParams), { searchInput: "", subject: "" }));
        // }
    };
    // Track when search value changes to set last action type
    useEffect(() => {
        const trimmedSearch = searchValue ? searchValue.trim() : "";
        if (trimmedSearch.length >= TrackedItemsVariables.MINIMUM_SEARCH_LENGTH) {
            setLastActionType("search");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);
    useEffect(() => {
        const trimmedSearch = searchValue ? searchValue.trim() : "";
        if (trimmedSearch.length >= 1 &&
            selectedTag) {
            SessionStorage.setKey("tiTag", null, sessionStorage);
            setSelectedTag(undefined);
        }
    }, [searchValue, selectedTag]);
    const handleTagPopupScroll = (e) => {
        const target = e === null || e === void 0 ? void 0 : e.target;
        if (!target)
            return;
        const nearBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 24;
        if (nearBottom && !tagLast && !tagSelectLoading) {
            setTagSelectLoading(true);
            dispatch(getMoreTags({
                page: (tagPage !== null && tagPage !== void 0 ? tagPage : 0) + 1,
                size: TAG_PAGE_SIZE,
                search: tagSearch || "",
            })).finally(() => setTagSelectLoading(false));
        }
    };
    const isHidden = selectedTab === TrackedItemsVariables.HIDDEN_TRACKED_ITEM;
    const buttonText = () => {
        if (selectedTab === TrackedItemsVariables.USER_TRACKED_ITEM) {
            return localize(["add", "TrackedItem.trackedItem"]);
        }
        else if (selectedTab === TrackedItemsVariables.SYSTEM_TRACKED_ITEM) {
            return localize(["add", "TrackedItem.indexCategory"]);
        }
        else {
            return localize(["add", "TrackedItem.hiddenTrackedItem"]);
        }
    };
    return (React.createElement("div", { ref: nodeRef },
        React.createElement(Header, { leftComponent: React.createElement(SelectedListingFilters, { filters: tabFilterValue(selectedTab) }), rightComponent: React.createElement("div", { className: "row", style: { alignItems: "center" } },
                React.createElement(ListingSearch, { placeholder: "Search (min 3 chars)", clientSide: false, minTextLength: 3, searchCallback: (val) => currentSearch.current = val, debounceTime: 1500 }),
                React.createElement(Select, { allowClear: true, showSearch: true, placeholder: "Filter by tag", value: selectedTag, style: { width: 200, marginRight: "10px", background: "#fff" }, dropdownStyle: { maxHeight: 280, overflow: "auto", background: "#fff" }, listHeight: 240, virtual: false, filterOption: false, loading: tagSelectLoading, onDropdownVisibleChange: (open) => {
                        setTagDropdownOpen(open);
                        if (!open) {
                            setTagSearchRaw("");
                            setTagSearch("");
                        }
                    }, onPopupScroll: handleTagPopupScroll, onSearch: (value) => setTagSearchRaw(value), onChange: (value) => handleTagSelectChange(value), options: availableTags === null || availableTags === void 0 ? void 0 : availableTags.map((tag) => ({
                        value: tag === null || tag === void 0 ? void 0 : tag.name,
                        label: tag === null || tag === void 0 ? void 0 : tag.name,
                    })), dropdownMatchSelectWidth: true }),
                React.createElement(FiltersDropdownMenu, { groupOptionValues: tabFilterValue("trackedItem_filters"), onChangeGroupOptions: handleChangeFilters, allowClearCompany: true, allowClearSite: true, onApply: handleApplyFilter }),
                React.createElement(PrintButton, { printOnClick: handlePrint }),
                React.createElement(Link, { to: {
                        pathname: addTrackedItemsRoute,
                    }, hidden: !isActionAllowed([REPORT_CREATION]) },
                    React.createElement(Button, { htmlType: "button", type: "primary" },
                        React.createElement(RenderSvg, { icon: "AddUserTrackItem" }),
                        buttonText()))) }),
        React.createElement(Tabs, { className: "definition-tabs-container", defaultActiveKey: selectedTab, activeKey: selectedTab, onChange: handleChange },
            React.createElement(TabPane, { tab: "Tracked Items", key: TrackedItemsVariables.USER_TRACKED_ITEM, id: "tracked-item-definitions" }, selectedTab === TrackedItemsVariables.USER_TRACKED_ITEM && (React.createElement(UserCreatedTrackedItemsListingContainer, { filters: tabFilterValue("trackedItem_filters"), isSubmitAction: isSubmitAction &&
                    selectedTab === TrackedItemsVariables.USER_TRACKED_ITEM, setIsSubmitAction: setIsSubmitAction, isHidden: false, selectedTag: selectedTag, lastActionType: lastActionType }))),
            React.createElement(TabPane, { tab: "Indices/Categories", key: TrackedItemsVariables.SYSTEM_TRACKED_ITEM, id: "tracked-item-types" }, selectedTab === TrackedItemsVariables.SYSTEM_TRACKED_ITEM && (React.createElement(SystemCreatedTrackedItemsListingContainer, { filters: tabFilterValue("trackedItem_filters"), isSubmitAction: isSubmitAction &&
                    selectedTab === TrackedItemsVariables.SYSTEM_TRACKED_ITEM, setIsSubmitAction: setIsSubmitAction, selectedTag: selectedTag, lastActionType: lastActionType }))),
            React.createElement(TabPane, { tab: React.createElement(Tooltip, { title: localize(["TrackedItem.hiddenItemsTooltip"]) }, "Tracked Item Components"), key: TrackedItemsVariables.HIDDEN_TRACKED_ITEM, id: "hidden-tracked-item-definition" }, selectedTab === TrackedItemsVariables.HIDDEN_TRACKED_ITEM && (React.createElement(UserCreatedTrackedItemsListingContainer, { filters: tabFilterValue("trackedItem_filters"), isSubmitAction: isSubmitAction &&
                    selectedTab === TrackedItemsVariables.HIDDEN_TRACKED_ITEM, setIsSubmitAction: setIsSubmitAction, isHidden: isHidden, selectedTag: selectedTag, lastActionType: lastActionType }))))));
};
export default ManageTrackedItemContainer;
